/** @format */

import React from "react";

export default () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 56 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.3998 30.6998H48.4998C47.9998 30.6998 47.4998 30.2998 47.4998 29.6998V20.4998C47.4998 9.89979 39.2998 0.899791 28.6998 0.499791C17.5998 0.0997911 8.3998 8.99979 8.3998 20.0998V29.7998C8.3998 30.2998 7.9998 30.7998 7.3998 30.7998H3.4998C1.9998 30.7998 0.799805 31.9998 0.799805 33.4998V68.8998C0.799805 70.3998 1.9998 71.5998 3.4998 71.5998H52.2998C53.7998 71.5998 54.9998 70.3998 54.9998 68.8998V33.3998C55.0998 31.8998 53.8998 30.6998 52.3998 30.6998ZM14.4998 20.0998C14.4998 12.3998 20.8998 6.19979 28.6998 6.59979C35.9998 6.99979 41.5998 13.1998 41.5998 20.4998V29.7998C41.5998 30.2998 41.1998 30.7998 40.5998 30.7998H15.3998C14.8998 30.7998 14.3998 30.3998 14.3998 29.7998V20.0998H14.4998Z"
      fill="#D9BB7F"
    />
  </svg>
);
